/**
 * Feeds API - Album post label copy (SCH-2109)
 *
 * The backend owns the words on an album post's label and the mobile and web
 * cards render them, so the copy lives here once instead of in each client.
 */

import type { FeedAlbum } from '../../schemas/entities/feed'

/** What an album post shows once its album has been deleted (R13). */
export const ALBUM_UNAVAILABLE_LABEL = 'This album is no longer available'

/**
 * The label on an album post: `"<album name> · <mediaCount> photos"`, or
 * {@link ALBUM_UNAVAILABLE_LABEL} when the album is gone.
 */
export function formatAlbumPostLabel(album: Pick<FeedAlbum, 'name' | 'mediaCount' | 'available'>): string {
  if (!album.available) return ALBUM_UNAVAILABLE_LABEL
  const noun = album.mediaCount === 1 ? 'photo' : 'photos'
  return `${album.name} · ${album.mediaCount} ${noun}`
}
